import { BefehlFormProps, BefehlFormWrapper } from '../Generic'
import { Befehl30 } from '../../../models'
import { useTranslation } from 'react-i18next'
import { Befehl30FormData, createBefehl30FormValidationSchema } from './schema'
import { useCallback } from 'react'
import {
  convertBefehl30FormDataToModel,
  convertModelToBefehl30FormData
} from './converters'
import { useBefehlForm } from '../../../hooks'
import Auftrag30_10Form from './Auftrag30_10Form'

export default function Befehl30Form({
  befehl,
  onSubmit,
  readOnly = false,
  'data-testid': testId = 'befehl-23-form',
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl30>>) {
  const { t } = useTranslation('ui-befehle')

  const formMethods = useBefehlForm<
    ReturnType<typeof createBefehl30FormValidationSchema>
  >({
    readOnly,
    activateEmptyFieldWarnings,
    schema: createBefehl30FormValidationSchema(),
    initialData: befehl ? convertModelToBefehl30FormData() : undefined
  })

  const handleSubmit = useCallback(
    (data: Befehl30FormData) => {
      const updatedBefehl = convertBefehl30FormDataToModel(
        data,
        befehl.frontendId
      )
      onSubmit(updatedBefehl)
    },
    [befehl.frontendId, onSubmit]
  )

  return (
    <BefehlFormWrapper<Befehl30FormData>
      befehlKennung="30"
      title={t('befehle.30.description')}
      formMethods={formMethods}
      onSubmit={handleSubmit}
      readOnly={readOnly}
      data-testid={`${testId}-wrapper`}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      displayHeaderOnly={displayHeaderOnly}
    >
      <Auftrag30_10Form data-testid={`${testId}-auftrag-30-10`} />
    </BefehlFormWrapper>
  )
}
